/* eslint-disable no-shadow */
import React, { Fragment, Component, ReactNode } from "react";
import { HashRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import NonPremiumModal from "./NonPremiumModal";
import ExportPdfModal from "./ExportPdf/ExportPdfModal";
import ActionBar from "../shared/general/ActionBar";
import Tabs from "./Tabs";
import ChartsPage from "./EmployerPerformance/ChartsPage";
import { setCurrentlySelectedCompany } from "../../actions/employerAnalyticsActions";

interface IEmployerAnalyticsProps {
  isPortalUser: boolean;
  hubAdminPresent: boolean;
  isPremiumOrPortalUser: boolean;
  isRootParentEmployer: boolean;
  parentChildEnabled: boolean;
  companyData: CompanyData;
  setCurrentlySelectedCompany: (
    company: Company,
    currentCompany: Company
  ) => void;
}

interface IEmployerAnalyticsState {
  exportModalActive: boolean;
  employerIdFilter: number | null;
}

export class EmployerInsights extends Component<
  IEmployerAnalyticsProps,
  IEmployerAnalyticsState
> {
  state: IEmployerAnalyticsState = {
    exportModalActive: false,
    // NOTE: NULL if filtering by a parent to see all it's children, or NULL if NOT a parent and want to see data as normal
    // this is only not null if the company is a parent and wants to filter for a particular child
    employerIdFilter: null,
  };

  toggleExportModal = (): void => {
    const { exportModalActive } = this.state;
    this.setState({ exportModalActive: !exportModalActive });

    document.body.classList.toggle("modalOverlay");
    window.scrollTo({
      top: 0,
    });
  };

  setSelectedCompany = (company: Company): void => {
    const { companyData, setCurrentlySelectedCompany } = this.props;
    const { currentCompany } = companyData;

    setCurrentlySelectedCompany(company, companyData.currentCompany);

    if (company.id === currentCompany.id) {
      this.setState({ employerIdFilter: null });
    } else {
      this.setState({ employerIdFilter: Number(company.id) });
    }
  };

  render(): ReactNode {
    const {
      isPortalUser,
      hubAdminPresent,
      isPremiumOrPortalUser,
      isRootParentEmployer,
      parentChildEnabled,
      companyData,
    } = this.props;
    const { employerIdFilter, exportModalActive } = this.state;
    const optionsCogData = [
      { id: 1, label: "Export to PDF", action: this.toggleExportModal },
    ];

    const showTabsMenu = isPortalUser && !isRootParentEmployer;

    return (
      <Fragment>
        <ActionBar
          title="insights"
          mobileTitle="insights"
          optionsCog
          optionsCogData={optionsCogData}
          companyData={companyData}
          childCompanyFilterTitleSuffix="Insights"
          setSelectedCompany={this.setSelectedCompany}
          isRootParentEmployer={isRootParentEmployer}
          parentChildEnabled={parentChildEnabled}
        />
        {!isPremiumOrPortalUser && !hubAdminPresent && <NonPremiumModal />}
        {exportModalActive && (
          <ExportPdfModal toggleModal={this.toggleExportModal} />
        )}
        {showTabsMenu ? (
          <Router>
            <Tabs
              hubAdminPresent={hubAdminPresent}
              isPortalUser={isPortalUser}
              isPremiumOrPortalUser={isPremiumOrPortalUser}
            />
          </Router>
        ) : (
          <ChartsPage
            hubAdminPresent={hubAdminPresent}
            isPortalUser={isPortalUser}
            employerIdFilter={employerIdFilter}
          />
        )}
      </Fragment>
    );
  }
}

interface Company {
  id: string;
  name: string;
}

interface CompanyData {
  selectedCompany: Company;
  currentCompany: Company;
  selectableCompanies: Company[];
}
interface IReduxState {
  employerAnalytics: {
    isPremiumOrPortalUser: boolean;
    isRootParentEmployer: boolean;
    companyData: CompanyData;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  isPremiumOrPortalUser: state.employerAnalytics.isPremiumOrPortalUser,
  isRootParentEmployer: state.employerAnalytics.isRootParentEmployer,
  companyData: state.employerAnalytics.companyData,
});

export default connect(
  mapStateToProps,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  { setCurrentlySelectedCompany }
)(EmployerInsights);
